export const TWITCH_SAVE_TOKEN = 'TWITCH_SAVE_TOKEN';
export const TWITCH_CLEAR_TOKEN = 'TWITCH_CLEAR_TOKEN';

export const TWITCH_SAVE_USER = 'TWITCH_SAVE_USER';
export const TWITCH_SAVE_FOLLOWED = 'TWITCH_SAVE_FOLLOWED';
export const TWITCH_SAVE_STREAMS = 'TWITCH_SAVE_STREAMS';
export const TWITCH_SAVE_GAMES = 'TWITCH_SAVE_GAMES';

export const TWITCH_FETCH_USER = 'TWITCH_FETCH_USER';
export const TWITCH_FETCH_USER_ERROR = `${TWITCH_FETCH_USER}_ERROR`;
export const TWITCH_FETCH_USER_SUCCESS = `${TWITCH_FETCH_USER}_SUCCESS`;
export const TWITCH_CLEAR_USER = 'TWITCH_CLEAR_USER';

export const TWITCH_FETCH_FOLLOWED_IDS = 'TWITCH_FETCH_FOLLOWED_IDS';
export const TWITCH_FETCH_FOLLOWED_IDS_ERROR = `${TWITCH_FETCH_FOLLOWED_IDS}_ERROR`;
export const TWITCH_FETCH_FOLLOWED_IDS_SUCCESS = `${TWITCH_FETCH_FOLLOWED_IDS}_SUCCESS`;
export const TWITCH_CLEAR_FOLLOWED_IDS = 'TWITCH_CLEAR_FOLLOWED_IDS';

export const TWITCH_FETCH_FOLLOWED_USERS = 'TWITCH_FETCH_FOLLOWED_USERS';
export const TWITCH_FETCH_FOLLOWED_USERS_ERROR = `${TWITCH_FETCH_FOLLOWED_USERS}_ERROR`;
export const TWITCH_FETCH_FOLLOWED_USERS_SUCCESS = `${TWITCH_FETCH_FOLLOWED_USERS}_SUCCESS`;
export const TWITCH_CLEAR_FOLLOWED_USERS = 'TWITCH_CLEAR_FOLLOWED_USERS';

export const TWITCH_CLEAR_FOLLOWED = 'TWITCH_CLEAR_FOLLOWED';

export const TWITCH_FETCH_STREAMS = 'TWITCH_FETCH_STREAMS';
export const TWITCH_FETCH_STREAMS_ERROR = `${TWITCH_FETCH_STREAMS}_ERROR`;
export const TWITCH_FETCH_STREAMS_SUCCESS = `${TWITCH_FETCH_STREAMS}_SUCCESS`;
export const TWITCH_CLEAR_STREAMS = 'TWITCH_CLEAR_STREAMS';

export const TWITCH_FETCH_GAMES = 'TWITCH_FETCH_GAMES';
export const TWITCH_FETCH_GAMES_ERROR = `${TWITCH_FETCH_GAMES}_ERROR`;
export const TWITCH_FETCH_GAMES_SUCCESS = `${TWITCH_FETCH_GAMES}_SUCCESS`;
export const TWITCH_CLEAR_GAMES = 'TWITCH_CLEAR_GAMES';

export const TWITCH_FETCH_VIDEOS = 'TWITCH_FETCH_VIDEOS';
export const TWITCH_FETCH_VIDEOS_ERROR = `${TWITCH_FETCH_VIDEOS}_ERROR`;
export const TWITCH_FETCH_VIDEOS_SUCCESS = `${TWITCH_FETCH_VIDEOS}_SUCCESS`;
export const TWITCH_CLEAR_VIDEOS = 'TWITCH_CLEAR_VIDEOS';

export const TWITCH_SET_CHANNEL = 'TWITCH_SET_CHANNEL';
export const TWITCH_CLEAR_CHANNEL = 'TWITCH_CLEAR_CHANNEL';

export const TWITCH_SET_VIDEO = 'TWITCH_SET_VIDEO';
export const TWITCH_CLEAR_VIDEO = 'TWITCH_CLEAR_VIDEO';

export const TWITCH_SET_SHOW_CHAT_STATE = 'TWITCH_SET_SHOW_CHAT_STATE';
export const TWITCH_SET_SHOW_VIDEOS_STATE = 'TWITCH_SET_SHOW_VIDEOS_STATE';

export const TWITCH_SET_REFRESH_INTERVAL = 'TWITCH_SET_REFRESH_INTERVAL';

export const TWITCH_CLEAR_ERRORS = 'TWITCH_CLEAR_ERRORS';
